export const paths = {
	home: "/",
	reports: "/report",
	poMapping: "/po-mapping",
	venueAliases: "/venue-aliases",
	aiConfidence: "/ai-confidence",
};
